var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4928 13.3377C16.342 13.1865 16.0972 13.1859 15.9459 13.3366L12.3867 16.8813V3.38672C12.3867 3.17314 12.2136 3 12 3C11.7864 3 11.6133 3.17314 11.6133 3.38672V16.8813L8.05413 13.3366C7.90282 13.186 7.65792 13.1865 7.50724 13.3377C7.35653 13.4891 7.35702 13.7339 7.50837 13.8847L11.7265 18.0856C11.8707 18.2351 12.1293 18.2351 12.2735 18.0856L16.4916 13.8847C16.643 13.7339 16.6435 13.489 16.4928 13.3377Z",
    fill: "#474747",
    stroke: "#474747",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 21H6.375C6.16143 21 5.98828 20.8269 5.98828 20.6133V18.5125C5.98828 18.2989 6.16143 18.1258 6.375 18.1258C6.58857 18.1258 6.76172 18.2989 6.76172 18.5125V20.2266H17.2383V18.5125C17.2383 18.2989 17.4114 18.1258 17.625 18.1258C17.8386 18.1258 18.0117 18.2989 18.0117 18.5125V20.6133C18.0117 20.8269 17.8386 21 17.625 21Z",
    fill: "#474747",
    stroke: "#474747",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.f3f2e0fe97f84aaa21d13ee47a7598e6.svg";
export { ForwardRef as ReactComponent };